var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Test"},[_c('p',[_vm._v("welcome to my test page!")]),_c('vue-aliplayer-v2',{ref:`VueAliplayerV2_0`,staticClass:"VueAliplayerV2Style",attrs:{"options":{
			..._vm.videoOptions,
			cover: 'https://inews.gtimg.com/newsapp_bt/0/14347237476/1000'
		},"source":"https://stream7.iqilu.com/10339/upload_transcode/202002/18/20200218114723HDu3hhxqIT.mp4"},on:{"ready":_vm.handleVideoReady}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }